module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }), _c('div', {
    staticClass: "chap_debut"
  }), _vm._v(" "), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Chapter One")])]), _vm._v(" "), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("In the beginning: human"), _c('br'), _vm._v("marriage as ‘one flesh’")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Like an untrained soldier thrown into the chaos of a battle already well advanced, the young nation of Israel was born into a world long violent with sin but unable to find the ways of peace. The late arriver urgently needed orientation. The teachings of the Pentateuch shaped Israel’s distinctive sense of national identity and mission by setting forth the great issues engulfing the world in conflict and by calling Israel to a bold commitment to the purpose of God."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN1",
      "id": "ap_NFIN1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" It placed the infant nation’s present situation against a much larger backdrop, tracing the story all the way back to its remotest origins in the book of Genesis – the creation, the fall, the division of the nations into warring factions and then the call of Abraham to bring the blessing of God’s rule to this troubled world. The covenant community could then see itself in a true light, rise above the vulgar preoccupations of common human existence and fulfill its holy calling.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Genesis 2:18-25, the account of the creation of the woman from the man, serves this larger purpose by opening up the profound inner meaning of the third line of Genesis 1:27:")]), _vm._v(" "), _c('div', {
    staticClass: "stroplg"
  }, [_c('p', {
    staticClass: "verslg"
  }, [_vm._v("So God created man in his own image,")]), _vm._v(" "), _c('p', {
    staticClass: "verslg type_1"
  }, [_vm._v("in the image of God he created him;")]), _vm._v(" "), _c('p', {
    staticClass: "verslg type_2"
  }, [_c('i', [_vm._v("male and female")]), _vm._v(" he created them ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("RSV")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }), _vm._v("One might have thought that this line merely prepares the way for verse 28, which assumes mankind’s capacity for sexual reproduction: ‘And God blessed them, and God said to them, “Be fruitful and multiply, and fill the earth…”’ After all, the lower creation was addressed not dissimilarly in verse 22: ‘And God blessed them, saying, “Be fruitful and multiply and fill the waters…”’ But human sexuality has a far deeper meaning than mere animal instinct, even if that instinct and capacity were imparted to the animals also through divine blessing. Along with the rest of human nature, God uses human sexuality to serve his redemptive purpose in the world. And so the Torah places before Israel the deeper meaning of human sexuality through the account of the first man and woman in the garden of Eden in chapter 2."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN2",
      "id": "ap_NFIN2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In verses 8-15 God prepares a place for the man. The garden is generously supplied not only with the necessities of life – food and water – which the original Israelite readers enduring the ‘howling waste of the wilderness’ (Dt. 32:10) must have envied, but also with rich luxuries to be wondered at under any circumstances."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN3",
      "id": "ap_NFIN3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Moreover, the tree of life within the garden functions as a sacramental device for sustaining the man indefinitely, presumably to be eaten daily to recharge the man’s batteries, as it were."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN4",
      "id": "ap_NFIN4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Another, the tree of the knowledge of good and evil, serves as guardian symbol and standard of God’s ultimate claim to rule in the garden. The man, for his part, is charged by God ‘to till and keep’"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN5",
      "id": "ap_NFIN5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" the garden. Perhaps implied "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }), _vm._v("here is humanity’s responsibility and opportunity to develop the garden until it would cover the entire earth, future generations living in one Edenic world, sustained by the divine means of grace and obedient to the Creator’s authoritative definition of what is good and what is evil."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN6",
      "id": "ap_NFIN6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In verses 16-17 God throws open to the man the freedom to enter into the joys of his new location of service."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN7",
      "id": "ap_NFIN7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" The only restriction is the forbidden tree of the knowledge of good and evil, by which God places before the man the choice of life or death. The concept of evil and the threat of certain death may have perplexed the first man in his unfallen state, especially with the tree of life there always to fall back on; but the Israelite reader would not have missed the poignancy of it.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Then, in verse 18, amid abundant provision, meaningful responsibility, personal care from God and splendid promise for the future, God puts his finger on the one flaw in this otherwise ideal environment: ‘It is not good that the man should be alone.’ Total perfection requires one more creative act, narrated in verses 19-22. The scene of unspoiled surroundings, clearly defined moral parameters and a strong incentive to follow the divine command moves toward completion as God provides the man with a helper uniquely suited to collaborate with him as his partner in advancing the purpose of God.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We are now prepared to read verses 23-24 more closely:")]), _vm._v(" "), _c('div', {
    staticClass: "stroplg"
  }, [_c('p', {
    staticClass: "verslg"
  }, [_c('i', [_c('sup', [_vm._v("23")])]), _vm._v("Then the man said,")]), _vm._v(" "), _c('p', {
    staticClass: "verslg type_1"
  }, [_vm._v("‘This at last is bone of my bones")]), _vm._v(" "), _c('p', {
    staticClass: "verslg type_2"
  }, [_vm._v("and flesh of my flesh;")]), _vm._v(" "), _c('p', {
    staticClass: "verslg type_1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }), _vm._v("this one shall be called Woman,")]), _vm._v(" "), _c('p', {
    staticClass: "verslg type_2"
  }, [_vm._v("for out of Man this one was taken.’")]), _vm._v(" "), _c('p', {
    staticClass: "verslg"
  }, [_c('i', [_c('sup', [_vm._v("24")])]), _vm._v("Therefore a man shall leave his father and his mother and cleave to his wife, and they shall become one flesh.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In the course of his naming of the animals the man came to realize that there was no other creature in the garden which fully shared his own nature, for his naming of them entailed not mere labelling but analysis, so that each name would be appropriate to the nature of each creature."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN8",
      "id": "ap_NFIN8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" This thoughtful exercise confronted him with one disappointment after another in relation to himself, so that he came to realize his own solitude within the vast complexity of the garden. He is now prepared for his final act of naming.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So ‘God himself, like a father of the bride, leads the woman to the man’ (von Rad 1972: 84). And the man, speaking either in praise to God or in unselfconscious wonder to himself, for these words are not directed to the woman but describe her in the third person – the man greets her with an intuitive sense of their congeniality. With the earliest recorded human words – and they are love poetry – the man expresses his exuberant joy at his first encounter with the woman. This one alone,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN9",
      "id": "ap_NFIN9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" this one at last,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN10",
      "id": "ap_NFIN10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" answers to the need of his heart, for she is bone of his bones and flesh of his flesh."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN11",
      "id": "ap_NFIN11-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" That is, he shares a close personal kinship with her as he does not with the animals, for he perceives that she has been built out of the stuff of his very body. A ‘bone and flesh’ mutuality, formally considered, may describe even a distant blood relation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN12",
      "id": "ap_NFIN12-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" But here, in the man’s glad recognition of the woman as his unique counterpart, sprung from himself, the sense is more personal and emotional. He "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }), _vm._v("rejoices in the woman as a creature truly fit for him. It is verse 24 which formalizes more clearly what this particular ‘bone and flesh’ relation entails.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Her name, ’"), _c('i', [_vm._v("i")]), _c('span', {
    staticClass: "mev2"
  }, [_c('i', [_vm._v("ššâ")])]), _c('i', [_vm._v("(h)")]), _vm._v(", Woman,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN13",
      "id": "ap_NFIN13-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" relative to his own, ’"), _c('span', {
    staticClass: "mev2"
  }, [_c('i', [_vm._v("îš")])]), _vm._v(", Man,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN14",
      "id": "ap_NFIN14-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" declares publicly her status as his only true companion in the garden. Unlike the animals – indeed, unlike the man himself – she did not come up from the ground below but out from human flesh, putting her alone at the man’s level. Verse 23b links this first meeting of man and woman with the larger task of the man’s naming of the creatures and yet sets the woman apart as superior to the other creatures the man had already named.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One is struck by the fact that the man does not say that the woman was taken ‘out of "), _c('i', [_vm._v("me")]), _vm._v("’ but ‘out of "), _c('i', [_vm._v("Man")]), _vm._v("’. He views both her and himself objectively. In 23a he speaks personally – ‘bone of "), _c('i', [_vm._v("my")]), _vm._v(" bones and flesh of "), _c('i', [_vm._v("my")]), _vm._v(" flesh’, which could be said literally of this first woman only. But in 23b the man speaks publicly and officially as the duly authorized Namer in the garden, setting a precedent for future generations of the race. He assumes his own identity as ’"), _c('span', {
    staticClass: "mev2"
  }, [_c('i', [_vm._v("îš")])]), _vm._v(", while formalizing the woman’s identity as ’"), _c('i', [_vm._v("i")]), _c('span', {
    staticClass: "mev2"
  }, [_c('i', [_vm._v("ššâ")])]), _c('i', [_vm._v("(h)")]), _vm._v(". The net effect makes clear her identity as fully human and yet different from himself.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Significantly, as will become evident in due course, this man with eyes undimmed by sin, in this moment of clear insight, nevertheless sees nothing before him but a woman in relation-ship to himself. The ultimate reality of a Saviour with his Bride, which the biblical story will eventually unveil as the mystery revealed through human marriage, does not fall within the range of the first man’s perception. No adumbrations of that "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }), _vm._v("mystery occur to him now. But what he does see and declare is enough for the curtain to rise meaningfully on the larger biblical drama.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Verse 24 breaks the continuity of the narrative – resumed in verse 25 – with the particle ‘Therefore’, intruding the narrator’s own parenthetical comment."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN15",
      "id": "ap_NFIN15-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" The more general question concerns whether verse 24 should be read as an historical explanation of human custom"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN16",
      "id": "ap_NFIN16-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" or as an authoritative injunction of human obligation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN17",
      "id": "ap_NFIN17-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" If the verse is merely descriptive of a general pattern of human behaviour – the sexes tending to pair off in marriage – then one wonders why so obvious a point receives such formal attention in the solemn tones of verse 24. If this verse were excised altogether, it would still not be difficult to make a meaningful connection between the remaining narrative and later human customs in marriage. Our interpretative intuitions would supply the link readily. Moreover, one wonders why Scripture would encumber itself with an observation so heavily in need of qualification. The plain fact, witnessed to already in Genesis 4:19, is that the definition of marriage set forth here in 2:24 is by no means universally accepted. It was not in Israel, perhaps even in the case of Moses, the hero of the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }), _vm._v("Torah."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN18",
      "id": "ap_NFIN18-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Finally, our Lord’s use of this passage in Matthew 19:3-9 assumes the prescriptive force of verse 24. We shall read this verse, therefore, as the inspired author’s pastoral application of verse 23 to his own historical situation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN19",
      "id": "ap_NFIN19-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This being so, verse 24 thrusts into the midst of a pre-fall human scene a word directly addressing post-fall people. After all, Adam did not have a father and a mother to leave. By means of this conspicuous verse, then, the text insists that the reader see the larger point to be derived from verse 23. Verse 24 is intended to exercise guiding and correcting power in one’s understanding of what marriage means and how one lives out that meaning in real life.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Three points are made in verse 24. First, a married man is to leave his father and his mother."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN20",
      "id": "ap_NFIN20-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" The expectation which the covenant community must accept as normative is that a new marriage will sever what is otherwise the strongest human bond, for it is the father and the mother whose very bodies give a man his life."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN21",
      "id": "ap_NFIN21-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" This requirement elevates the marital union above all other personal loyalties, under God. If, in marrying, a man withdraws his primary allegiance from his parents and redirects it to his wife so that they enter into a ‘one flesh’ existence, how much more does this distinguish marriage from all other relationships as well! Marriage is so profound a union that not only "), _c('i', [_vm._v("may")]), _vm._v(" one put one’s wife ahead of all others, one "), _c('i', [_vm._v("must")]), _vm._v(" do so.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Secondly, a married man is to cleave to, or cling to, his wife. As the positive complement to the preceding clause, this requires "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }), _vm._v("and permits the man to devote his primary loyalty to his wife."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN22",
      "id": "ap_NFIN22-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" And what does this cleaving look like in life? The language suggests that, physically, the man takes his wife in his arms, so that in the course of normal life their marriage is frequently symbolized, celebrated and refreshed through sexual union. Emotionally, the man fixes upon her alone his deepest affections, under God, with a profound sense of attachment, contentment and fulfilment."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN23",
      "id": "ap_NFIN23-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" And formally or socially, the man lives with his wife in a covenant of strictly inviolable exclusivity, separating him from all others on the earth."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN24",
      "id": "ap_NFIN24-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Thirdly, the man and his wife are to become ‘one flesh’. The new life created by a marriage fuses a man and wife together into one, fully shared human experience, prompting mutual care, tenderness and love. It is at this point that the logical connection with verse 23b becomes most clear. There, as also in verse 21, the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }), _vm._v("word ‘flesh’ is meant literally. Here in verse 24, however, a higher sense is intended. By metonymy, this use of ‘flesh’ accomplishes two things at once. On the one hand, it affirms the true, if not ‘blood’, kinship between the man and the woman."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN25",
      "id": "ap_NFIN25-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" On the other hand, it whispers the temporal limitation inherent in the marriage relationship."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN26",
      "id": "ap_NFIN26-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" What strikes the reader is both that this is a ‘"), _c('i', [_vm._v("one")]), _vm._v(" flesh’ relationship, and also that it is a ‘one "), _c('i', [_vm._v("flesh")]), _vm._v("’ relation-ship. A ‘"), _c('i', [_vm._v("one")]), _vm._v(" flesh’ union is unparalleled in human relationships, which argues for the uniqueness of the marital bond – a point already established. But, additionally, any union defined in terms of "), _c('i', [_vm._v("flesh")]), _vm._v(" must be acknowledged to be less than ultimate in nature. It extends for the full length of this mortal life, but it cannot transcend this life. Marriage, therefore, is the deepest human relationship, but not even this relationship qualifies as a final experience. (Again, one bears in mind that verse 24 is an admonition to post-fall readers inserted into a record of pre-fall events.) There comes a day when every married man, stripped of everything he cherishes in this life, must let go even of his beloved wife’s hand. Marriage is profound, but not ultimate.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("To sum up, human marriage is premised in the making of the woman out of the very flesh of the man,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN27",
      "id": "ap_NFIN27-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" so that the bond of marriage reunites what was originally and literally one flesh. All other relational claims must yield to the primacy of marital union. It requires an exclusive, life-long bonding of one man with one woman in one life fully shared. It erects barriers around the man and woman, and it destroys all barriers between the man and the woman. God so joins them together that they belong fully to one another, and to one another only.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This is the vision of human marriage which provides the coherent network of meanings necessary for an understanding of the covenanted nation’s relationship with Yahweh, as the story unfolds in the rest of Scripture.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c23490d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chap1.vue
// module id = 78
// module chunks = 0